import React from "react";
import { ArrowRightIcon } from "lucide-react";
interface LinkButtonProps {
  href: string;
  children: React.ReactNode;
  variant?: "primary" | "secondary" | "ghost";
  className?: string;
  withArrow?: boolean;
}
const base = "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full font-semibold transition-[background-color,color,border-color,transform] duration-150 ease-out active:scale-[0.98]";
const variants = {
  primary: "bg-terracota-deep px-7 py-4 text-base text-papel hover:bg-[#7C4439]",
  secondary: "border border-pizarra/30 bg-papel/60 px-6 py-3.5 text-base text-pizarra-deep hover:border-pizarra hover:bg-papel",
  ghost: "px-2 py-2 text-pizarra-deep underline decoration-dorado underline-offset-4 hover:text-terracota-deep"
};
export function LinkButton({
  href,
  children,
  variant = "primary",
  className = "",
  withArrow = false
}: LinkButtonProps) {
  return <a href={href} className={`${base} ${variants[variant]} ${className}`} data-id="element-308" data-mp="1dmhpapbeun69">
      {children}
      {withArrow && <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-309" data-mp="35dgykpbz4wrf" />}
    </a>;
}